'use client';
import {Cookies} from "react-cookie";
const cookie = new Cookies();

export function getCId(): string | undefined {
  return getVid() || getUId();
}

export function getVid(): string | undefined {
  const match = document.cookie.match(/_ga=GA\d+\.\d+\.(.+?)(?:;|$)/);
  return match?.[1] ?? undefined;
}

export function getUId(): string | undefined {
  return cookie.get('__opix_uid') || localStorage.getItem('__opix_uid');
}
